export const handleFunctionalCookies = (setCookie: Function) => {
   setCookie("_hjAbsoluteSessionInProgress", true);
   setCookie("__cf_bm", true);
   setCookie("__hssc", true);
};

export const handleAnalyticsCookies = (setCookie: Function) => {
   setCookie("hubspotutk", true);
   setCookie("__hstc", true);
   setCookie("_hjRecordingLastActivity", true);
   setCookie("_ga", true);
   setCookie("_ga_*", true);
   setCookie("_gat_gtag_UA_*", true);
   setCookie("_gid", true);
   setCookie("_fbp", true);
   setCookie("_hjSession_*", true);
   setCookie("_hjFirstSeen", true);
   setCookie("_hjSessionUser_", true);
};

export const handleUncategorizedCookies = (setCookie: Function) => {
   setCookie("_hjIncludedInSessionSample_3470175", true);
};

export const handleRejectAll = (removeCookie: Function) => {
   removeCookie("_hjAbsoluteSessionInProgress");
   removeCookie("__cf_bm");
   removeCookie("__hssc");
   removeCookie("_hjIncludedInSessionSample_3470175");
   removeCookie("hubspotutk");
   removeCookie("__hstc");
   removeCookie("_hjRecordingLastActivity");
   removeCookie("_ga");
   removeCookie("_ga_*");
   removeCookie("_gat_gtag_UA_*");
   removeCookie("_gid");
   removeCookie("_fbp");
   removeCookie("_hjSession_*");
   removeCookie("_hjFirstSeen");
   removeCookie("_hjSessionUser_");
};
